/**
 * Hover-to-preview for the small color-circle swatches under each product card on collection
 * grids. Hovering (or focusing, for keyboard users) a swatch swaps the card's main image to
 * that color's first photo, without navigating — clicking still follows the link normally.
 * Event delegation on document so this works for cards added later (e.g. infinite scroll,
 * section re-renders) without re-binding.
 *
 * Cards that also have "show second image on hover" enabled render TWO stacked <img> elements
 * inside .media--hover-effect, and Dawn's own CSS reveals the second one via opacity as soon as
 * the card-wrapper is :hover'd — which happens the moment the pointer is anywhere inside the
 * card, including over these swatches. So both images need the swapped src, not just the first
 * one, or Dawn's own hover effect silently wins and nothing visibly changes.
 */
(function () {
  function findCardImages(swatchLink) {
    var cardWrapper = swatchLink.closest('.card-wrapper');
    if (!cardWrapper) return [];
    return Array.prototype.slice.call(cardWrapper.querySelectorAll('.card__media .media--hover-effect > img'));
  }

  function handleEnter(event) {
    var swatchLink = event.target.closest('[data-card-color-swatch]');
    if (!swatchLink) return;
    var hoverSrc = swatchLink.getAttribute('data-hover-image');
    if (!hoverSrc) return;
    var images = findCardImages(swatchLink);

    images.forEach(function (img) {
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.currentSrc || img.src;
      }
      if (img.hasAttribute('srcset') && !img.dataset.originalSrcset) {
        img.dataset.originalSrcset = img.getAttribute('srcset');
      }
      img.removeAttribute('srcset');
      img.src = hoverSrc;
    });
  }

  function handleLeave(event) {
    var swatchLink = event.target.closest('[data-card-color-swatch]');
    if (!swatchLink) return;
    var images = findCardImages(swatchLink);

    images.forEach(function (img) {
      if (!img.dataset.originalSrc) return;
      img.src = img.dataset.originalSrc;
      if (img.dataset.originalSrcset) {
        img.setAttribute('srcset', img.dataset.originalSrcset);
      }
    });
  }

  document.addEventListener('mouseover', handleEnter);
  document.addEventListener('mouseout', handleLeave);
  document.addEventListener('focusin', handleEnter);
  document.addEventListener('focusout', handleLeave);
})();
